module.exports = __webpack_public_path__ + "static/media/INFOG1.1c449000.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/INFOG1.png
// module id = 255
// module chunks = 0